import {
  apiRoutes,
  getProvincesFn,
  type DefaultQueryError,
  type Province,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetProvinces = (
  opts?: UseQueryOptions<Province[], DefaultQueryError>
) =>
  useQuery<Province[], DefaultQueryError>({
    queryKey: [apiRoutes.intercity.provinces],
    queryFn: () => getProvincesFn(),
    ...opts,
  });
